import React, { useContext } from 'react';

import { Box, BorderBox, Heading, Text, ButtonPrimary, StyledOcticon } from '@primer/components'
import { LinkExternal } from '@primer/octicons-react'
import { Link } from "react-router-dom"

import WaveHero from '../../components/WaveHero'

import useScreen from '../../hooks/useScreen'
import useAnalytics from '../../hooks/useAnalytics'
import * as constants from '../../constants'
import Card from '../../components/BeforeAfter/CardWithContext'
import { CorpusContext } from '../../hooks/useCorpus' 



export default function(props) {
  const analytics = useAnalytics()
  const { corpus } = useContext(CorpusContext)
  const example = corpus[props.exampleCode]
  const hasDelta = example.exampleAfter !== example.exampleBefore

  return (
    <WaveHero>
      <Box className="container-lg pt-md-8 mb-10 pl-2 pr-2 pl-md-4 pr-md-4">
        <Box className="text-white m-md-0 text-center">
          <Heading as="h1" fontSize={58} paddingTop="15px" className="mb-4" lineHeight={"1em"}>{props.headline}</Heading>
          <Text
            as="p"
            fontSize={4}
            className="text-white pl-2 pr-2 pl-md-0 pl-md-0"
          >{props.synopsis}</Text>
        </Box>
        <Box className="mt-2 mt-md-4">
          <Card
            textClassName={"text-black"}
            {...example}
            hasDelta={hasDelta}
            linesOffset={0}
            minimalistAdvice={false}
            scmKey={constants.SCM_BITBUCKET}
          />
        </Box>
        <Box className="position-relative mt-6">
          <Text as="h3" className="text-center">
            <a href={props.linkUrl} className="text-white" target="_blank">
              <ButtonPrimary
                as={Link}
                variant="large"
                className="f3 pt-3 pb-3 pl-3 pr-3"
                onClick={() => analytics.trackOnce('LKEQFH0W')}
                to={'/features/bitbucket/price'}
              >
                {props.linkText}
              </ButtonPrimary>
            </a>
          </Text>
        </Box>      

      </Box>
    </WaveHero>
  )
}